// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Status (realtime changes) to a `ServiceJourney` and might impact planned routing.
 * @export
 * @interface ServiceAlteration
 */
export interface ServiceAlteration {
    /**
     * true: Journey is `cancelled` (de:Ausfall), default=false.
     * @type {boolean}
     * @memberof ServiceAlteration
     */
    cancelled: boolean;
    /**
     * If `cancelled`, enduser cancellation info.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof ServiceAlteration
     */
    cancelledFormatted?: string;
    /**
     * true: Journey is partially cancelled (de:Teilausfall) at beginning or end, default=false.
     * @type {boolean}
     * @memberof ServiceAlteration
     */
    partiallyCancelled: boolean;
    /**
     * If `partiallyCancelled`, enduser info.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof ServiceAlteration
     */
    partiallyCancelledFormatted?: string;
    /**
     * true: vehicle (`ServiceProduct`) change connection from `PTRideLeg` to `PTRideLeg` is possible (de: Anschluss kann gehalten werden, see `Trip::status::valid`); false: de:nicht mehr erreichbare Fahrt
     * @type {boolean}
     * @memberof ServiceAlteration
     */
    reachable: boolean;
    /**
     * Transport-product change from Leg to Leg info according to SBB business rules. Relates to reachable.
     * @type {string}
     * @memberof ServiceAlteration
     */
    reachableFormatted?: string;
    /**
     * true: journey is redirected (aka OJP deviation).
     * @type {boolean}
     * @memberof ServiceAlteration
     */
    redirected: boolean;
    /**
     * Text intended for passengers about a planned stop being skipped, relates to `redirected`.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof ServiceAlteration
     */
    redirectedFormatted?: string;
    /**
     * Text intended for passengers about an additional non-planned stop at a station.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof ServiceAlteration
     */
    unplannedStopPointsFormatted?: string;
    /**
     * Enduser text, saying whether there is a delay on PTRideLeg (referring to first/last Stop).<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof ServiceAlteration
     */
    delayFormatted?: string;
    /**
     * Enduser text, saying whether there is a `Quay` change on `ServiceJourney` (typically referring to first and/or last `ScheduledStopPoint` on a `PTRideLeg`), which indicates the passengers to be careful at boarding/alighting.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof ServiceAlteration
     */
    quayChangedFormatted?: string;
}

/**
 * Check if a given object implements the ServiceAlteration interface.
 */
export function instanceOfServiceAlteration(value: object): value is ServiceAlteration {
    if (!('cancelled' in value) || value['cancelled'] === undefined) return false;
    if (!('partiallyCancelled' in value) || value['partiallyCancelled'] === undefined) return false;
    if (!('reachable' in value) || value['reachable'] === undefined) return false;
    if (!('redirected' in value) || value['redirected'] === undefined) return false;
    return true;
}

export function ServiceAlterationFromJSON(json: any): ServiceAlteration {
    return ServiceAlterationFromJSONTyped(json, false);
}

export function ServiceAlterationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAlteration {
    if (json == null) {
        return json;
    }
    return {
        
        'cancelled': json['cancelled'],
        'cancelledFormatted': json['cancelledFormatted'] == null ? undefined : json['cancelledFormatted'],
        'partiallyCancelled': json['partiallyCancelled'],
        'partiallyCancelledFormatted': json['partiallyCancelledFormatted'] == null ? undefined : json['partiallyCancelledFormatted'],
        'reachable': json['reachable'],
        'reachableFormatted': json['reachableFormatted'] == null ? undefined : json['reachableFormatted'],
        'redirected': json['redirected'],
        'redirectedFormatted': json['redirectedFormatted'] == null ? undefined : json['redirectedFormatted'],
        'unplannedStopPointsFormatted': json['unplannedStopPointsFormatted'] == null ? undefined : json['unplannedStopPointsFormatted'],
        'delayFormatted': json['delayFormatted'] == null ? undefined : json['delayFormatted'],
        'quayChangedFormatted': json['quayChangedFormatted'] == null ? undefined : json['quayChangedFormatted'],
    };
}

  export function ServiceAlterationToJSON(json: any): ServiceAlteration {
      return ServiceAlterationToJSONTyped(json, false);
  }

  export function ServiceAlterationToJSONTyped(value?: ServiceAlteration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cancelled': value['cancelled'],
        'cancelledFormatted': value['cancelledFormatted'],
        'partiallyCancelled': value['partiallyCancelled'],
        'partiallyCancelledFormatted': value['partiallyCancelledFormatted'],
        'reachable': value['reachable'],
        'reachableFormatted': value['reachableFormatted'],
        'redirected': value['redirected'],
        'redirectedFormatted': value['redirectedFormatted'],
        'unplannedStopPointsFormatted': value['unplannedStopPointsFormatted'],
        'delayFormatted': value['delayFormatted'],
        'quayChangedFormatted': value['quayChangedFormatted'],
    };
}

